import { Flex, Text } from "@chakra-ui/react";
import { SingleDatepicker } from "chakra-dayzed-datepicker";

interface DatepickerWithLabelProps {
  label: string;
  date: any;
  onDateChange: (dt: any) => void;
  placeholder?:string;
  name:string

}

const Datepicker: React.FC<DatepickerWithLabelProps> = ({
  name,
  label,
  date,
  onDateChange,
  placeholder
}) => (
  <Flex w="100%" display="flex" flexDirection="column">
    <Text mr={2}>{label}</Text>
    <SingleDatepicker
      date={date}
      onDateChange={(dt: any) => onDateChange(dt)}
      name={name}
      id={"jdsklf"}
      configs={{
        dateFormat: "dd-MM-yyyy",
      }}
      propsConfigs={{
        dayOfMonthBtnProps: {
          defaultBtnProps: {
            // borderColor: "red.300",
            _hover: {
              background: 'teal.300',
            }
          },
          selectedBtnProps: {
            background: "teal.400",
          },
          todayBtnProps: {
            background: "teal.400",
          }
        } as any,
        inputProps: {
          size: "sm",
          w:'100%',
          placeholder:placeholder ? placeholder : "Select a date",
          style: {
            width: "100%",
          },
        },
      }}
    />
  </Flex>
);

export default Datepicker;